import { render, staticRenderFns } from "./ElectronicList.vue?vue&type=template&id=fa7e1648&"
import script from "./ElectronicList.vue?vue&type=script&lang=js&"
export * from "./ElectronicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ElectronicList.vue"
export default component.exports